import { HttpClient } from '../../httpClient'
import { throwIfNotAllowedContentType, validateHttpResponse } from '../../httpClient/utils.ts'

export const getUserOrganizationRoles = async (client: HttpClient, userId: string) => {
	const response = await client.get(`/api/users/${userId}/roles`)

	await validateHttpResponse(response)
	throwIfNotAllowedContentType(response, ['application/json'])

	return response.data
}
